document.addEventListener("DOMContentLoaded", function () {
  initMcStickyScroll();
});

function initMcStickyScroll() {
  window.addEventListener("scroll", handleScroll, { passive: true });
  handleScroll();
}

function handleScroll() {
  const announcementBar = document.querySelector(".mc-announcement-bar");
  const topbar = document.querySelector(".mc-topbar");
  const navbar = document.querySelector(".mc-navbar");

  if (!topbar || !navbar) return;

  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  const announcementBarHeight = announcementBar
    ? announcementBar.offsetHeight
    : 0;

  if (isMobile) {
    handleMobileSticky(scrollTop, announcementBarHeight, topbar, navbar);
  } else {
    handleDesktopSticky(scrollTop, announcementBarHeight, topbar, navbar);
  }
}

function handleMobileSticky(scrollTop, announcementBarHeight, topbar, navbar) {
  if (scrollTop > announcementBarHeight) {
    topbar.classList.add("mc-sticky");
    topbar.style.position = "fixed";
    topbar.style.top = "0";
    topbar.style.left = "0";
    topbar.style.right = "0";
    topbar.style.zIndex = "2";

    navbar.classList.add("mc-sticky");
    navbar.style.position = "fixed";
    navbar.style.top = `${topbar.offsetHeight - 1}px`;
    navbar.style.left = "0";
    navbar.style.right = "0";
    navbar.style.zIndex = "1";

    document.body.style.paddingTop = `${
      topbar.offsetHeight + navbar.offsetHeight - 1
    }px`;
  } else {
    topbar.classList.remove("mc-sticky");
    topbar.style.position = "";
    topbar.style.top = "";
    topbar.style.left = "";
    topbar.style.right = "";
    topbar.style.zIndex = "";

    navbar.classList.remove("mc-sticky");
    navbar.style.position = "";
    navbar.style.top = "";
    navbar.style.left = "";
    navbar.style.right = "";
    navbar.style.zIndex = "";

    document.body.style.paddingTop = "";
  }
}

function handleDesktopSticky(scrollTop, announcementBarHeight, topbar, navbar) {
  if (scrollTop > announcementBarHeight) {
    topbar.classList.add("mc-sticky");
    topbar.style.position = "fixed";
    topbar.style.top = "0";
    topbar.style.left = "0";
    topbar.style.right = "0";
    topbar.style.zIndex = "2";

    navbar.classList.add("mc-sticky");
    navbar.style.position = "fixed";
    navbar.style.top = `${topbar.offsetHeight - 1}px`;
    navbar.style.left = "0";
    navbar.style.right = "0";
    navbar.style.zIndex = "1";

    document.body.style.paddingTop = `${
      topbar.offsetHeight + navbar.offsetHeight - 1
    }px`;
  } else {
    topbar.classList.remove("mc-sticky");
    topbar.style.position = "";
    topbar.style.top = "";
    topbar.style.left = "";
    topbar.style.right = "";
    topbar.style.zIndex = "";

    navbar.classList.remove("mc-sticky");
    navbar.style.position = "";
    navbar.style.top = "";
    navbar.style.left = "";
    navbar.style.right = "";
    navbar.style.zIndex = "";

    document.body.style.paddingTop = "";
  }
}
